module.exports = '<div id="map" ngNonBindable></div>\n';